import { useMutation } from "@apollo/client/react";
import toast from "react-hot-toast";
import moment from 'moment';
import { SAVE_INDICATION } from "../../../../../data/graphQL/mutations/GestionAsistencial/saveIndication";
import { CompareDates } from "../../../../../utils/helpers";

export function useTabIndicationEditIndicacionOnSubmit({
  idEvaluacion,
  idIndicacion,
  formValues,
  insumos,
  handleCloseDialog,
  refetch,
  fechaDesdeOriginal
}) {
  const [saveIndicacion, { loading: saveIndicationLoading }] = useMutation(SAVE_INDICATION);

  const formatInsumosPayload = (insumosAdded) => {
    const insumosFormatted = insumosAdded.map((item) => ({
      idInsumo: item.idInsumoN,
      cantidad: +item.cantidad,
      idUnidad: +item.idUnidad
    }));

    return insumosFormatted;
  };

  const onSubmitSaveIndication = () => {
    if (CompareDates(formValues.fechaDesde, formValues.fechaHasta) === 1) {
      return toast.error(
        "La fecha desde debe ser menor o igual a la fecha hasta."
      );
    }

    // fecha de solicitud posterior al día actual
    // if (CompareDates(formValues.fechaDesde, moment(fechaDesdeOriginal).format('YYYY-MM-DD')) != 1) {
    //   return toast.error(
    //     "La fecha desde a modificar debe ser posterior a la fecha desde original."
    //   );
    // }

    saveIndicacion({
      variables: {
        input: {
          idEvaluacion,
          idIndicacion,
          fechaDesde: moment(formValues.fechaDesde).format("YYYY-MM-DD"),
          fechaHasta: moment(formValues.fechaHasta).format("YYYY-MM-DD"),
          observacion: formValues.observacion,
          productos: formatInsumosPayload(insumos)
        }
      },
      onCompleted: (data) => {
        const { success, error } = data?.saveIndicacion ?? {};
        if (!success) {
          toast.error(error);
        } else {
          toast.success("Indicación editada con éxito");
          refetch();
          handleCloseDialog();
        }
      }
    });
  };

  return { onSubmitSaveIndication, saveIndicationLoading };
}